export default __webpack_public_path__ + "static/media/emptyData.d2bc575e.svg";